import axios from "axios";
import $storage from "../util/stroage.js";

const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    // easy-mock服务挂了，暂时不使用了
    // baseURL: 'https://www.easy-mock.com/mock/592501a391470c0ac1fab128',
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
    timeout: 5000
});

//http request 拦截器
// service.interceptors.request.use(
//     config => {
//       config.data = JSON.stringify(config.data);
//       config.headers = {
//         'Content-Type':'application/x-www-form-urlencoded'
//       }
//       return config;
//     },
//     error => {
//       return Promise.reject(err);
//     }
//   );

// service.interceptors.request.use(
//     config => {
//         return config;
//     },
//     error => {
//         console.log(error);
//         return Promise.reject();
//     }
// );

service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('userInfo');
        if(token){
          const tokendata = JSON.parse(token);
          config.headers.tk = tokendata.tk;
        }
        config.headers.userType=1;
        return config;
    },
    error => Promise.error(error))

/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(url, params = {}, headers = {}) {
    // debugger
    return new Promise((resolve, reject) => {
        // console.log(params,'params')
        // debugger
        service
            .get(url, {
                params: params
            })
            .then(response => {
                resolve(response);
            })
            .catch(err => {
                reject(err);
            });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        service.post(url, data,headers).then(
            response => {
                resolve(response);
            },
            err => {
                reject(err);
            }
        );
    });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        service.patch(url, data).then(
            response => {
                resolve(response);
            },
            err => {
                reject(err);
            }
        );
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        service.put(url, data).then(
            response => {
                resolve(response);
            },
            err => {
                reject(err);
            }
        );
    });
}

// export default service;



// WEBPACK FOOTER //
// ./src/util/request.js